// extracted by mini-css-extract-plugin
export default {"TagWrapper":"Tag_TagWrapper__xFqkM"};